import Notifiq from "@/Pages/Notifiq/index.vue";
import IndexNotifiq from "@/Pages/Notifiq/IndexNotifiq.vue";
import IndexPontoFiqColaboradores from "@/Pages/Notifiq/IndexPontoFiqColaboradores.vue";

export default [
  {
    path: "/notifiq/presencas",
    name: "notifiq.indexNotifiq",
    title: "Presença Notifiq",
    component: IndexNotifiq,
  },
  {
    path: "/notifiq/ponto-fiq-colaboradores",
    name: "notifiq.indexPontoFiqColaboradores",
    title: "Presença PontoFiq Colaboradores",
    component: IndexPontoFiqColaboradores,
  },
];
